module.exports = __webpack_public_path__ + "images/company_profile/icon06-f091e16f905c86c48b4ae0fc241a866c.png";